import React, { useState, useEffect, useContext } from "react" 
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from "../context/journeyContext"
import {fetchAllJourneyData, sendSelectedOptions, saveApplication, checkBIExists, fetchSucRules, fetchTeleMerEligibility, fetchApplicationDetails, updateUserTrackerDetails } from "../../services/apiservice"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { getStateFromCode, getDateInFormat, findCurrentJourneyCode, getValueFromLookup, getAge, DataLayerIntegration } from "../services/helperFunctions"
import * as moment from "moment"
import * as lookup from "../../../static/lookup.json";
import {lineCapital, maskInFormat} from '../../shared/functions';
export default function ProvideYourConsent(props) {
  const [apiResult, setApiResult] = useState(null)
  const [sucRulesResult, setSucRulesResult] = useState(null)
  const [datatoPass, setDataToPass] = useState({
    "allJourneyData": null,
    "proceedOption": null,
    "addressOption": null
  })
  const [checked, setChecked] = useState()
  const [proceedOptionError, setProceedOptionError] = useState("")

  const state = lookup["state"];
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  const checkNegativePincode = (pincode) => {  
    //Checking for negative Pincode
    const negativePincodes = lookup["negativePincodes"]
    let index = negativePincodes.findIndex(element => element === pincode)
    if(index !== -1){
      let conditionStateValueEducationQualification
      let conditionStateValueAnnualIncome
      if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
        conditionStateValueEducationQualification = conditionState["calculatePremiumPage.CPPersonalDetailsSection.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["calculatePremiumPage.CPPersonalDetailsSection.AnnualIncome"]
      }
      else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
        conditionStateValueEducationQualification = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.AnnualIncome"]
      }
      else if(journeyState.journeyIdFromStrapi === "youngTermPlanJourney"){
        conditionStateValueEducationQualification = conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["PageYoungTermCalculatePremium.sectionYoungTermPersonalDetailsSection.AnnualIncome"]
      }
      else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
        conditionStateValueEducationQualification = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.educationalQualification"]
        conditionStateValueAnnualIncome = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.AnnualIncome"]
      }
      if(!["1","2"].includes(conditionStateValueEducationQualification)){
        return true
      }else{
        if(conditionStateValueAnnualIncome < 500000){
          return true
        }else {
          return false
        }
      } 
    }else{
      return false
    }
  }

  const getAllJourneyData = async () => {
    let payload = {
      // "journeyId":"60af3842ea22f32efbf53d4a"
      "journeyId": journeyState.journeyId
    }
    let temp = await fetchAllJourneyData(payload)
    console.log(temp, "reponse from provide your consent")
    setApiResult(temp)

    if(temp?.lifeAssuredDetails?.matchTypeDedupe){
      setJourneyState((prev) => {
        return ({
          ...prev,
          'dedupeResult' : temp?.lifeAssuredDetails?.matchTypeDedupe
        })
      })
    }

    //for selecting default option for proceed option
    if(temp.lifeAssuredDetails.kycVerified){
      let isKycPincodeNegative = checkNegativePincode(temp.lifeAssuredDetails?.kycDetails?.adharAddressPin)
      if(isKycPincodeNegative){
        setDataToPass(prev => {
          return ({
            ...prev,
            "allJourneyData": temp,
            "proceedOption": "manually",
            "addressOption": "both"
          })
        })
        setChecked("manual")
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
          selectedOption : "ekyc"
        }
        checkBIExists(payload)
        .then(res => {
          console.log(res, "dsfdfdsfd")
          if(!res.data){
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "manually",
                "addressOption": "both"
              })
            })
            setChecked("manual")
          }else{
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "ekyc",
                "addressOption": "both"
              })
            })
            setChecked("ekyc")
          }
        })
      }
    }else if(temp.lifeAssuredDetails.ckycVerified){
      let isCkycPincodeNegative = checkNegativePincode(temp?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddPin)
      if(isCkycPincodeNegative){
        setDataToPass(prev => {
          return ({
            ...prev,
            "allJourneyData": temp,
            "proceedOption": "manually",
            "addressOption": "both"
          })
        })
        setChecked("manual")
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
          selectedOption : "ckyc"
        }
        checkBIExists(payload)
        .then(res => {
          console.log(res, "dsfdfdsfd")
          if(!res.data){
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "manually",
                "addressOption": "both"
              })
            })
            setChecked("manual")
          }else{
            setDataToPass(prev => {
              return ({
                ...prev,
                "allJourneyData": temp,
                "proceedOption": "ckyc",
                "addressOption": "both"
              })
            })
            setChecked("ckyc")
          }
        })
      }
    }else if(temp?.lifeAssuredDetails?.matchTypeDedupe){
      setDataToPass(prev => {
        return ({
          ...prev,
          "allJourneyData": temp,
          "proceedOption": "dedupe",
          "addressOption": "both"
        })
      })
      setChecked("dedupe")
    }else if(temp?.basicDetails?.ckycSkip === true && temp?.basicDetails?.ekycSkip === true){
      let datatoPass = {
        "allJourneyData": temp,
          "proceedOption": "manually",
          "addressOption": "both"
      }
      setDataToPass(prev => {
        return ({
          ...prev,
          "allJourneyData": temp,
          "proceedOption": "manually",
          "addressOption": "both"
        })
      })
      setChecked("manual")
      if(proceedOptionError){
        if(proceedOptionError === "This pincode is not serviceable"){
          errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : journeyState.journeyIdFromStrapi === "youngTermPlanJourney" ? "Young Term Plan" : ""}. Basis your input this Plan is not available.`)
          return 
        }else{
          errorToastr("BI could not be generated for the details selected. Please proceed by selecting any other option")
          return 
        }
      }
      console.log(journeyState);
      let sendPayload = {
        applicationData:  journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          premium: journeyState.premium,
          planOption: journeyState.planOption,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        },
      }

      let changeJourneySteps = journeyState.journeySteps
      if (journeyState?.journeyType?.toLowerCase() === "canarapos" && temp.productDetails.premiumFrequency === "SG") {
        changeJourneySteps.pages = changeJourneySteps.pages.filter(
          page => page.pageId !== "makePayment"
        )
      }else if (journeyState?.journeyType?.toLowerCase() === "canarapos") {
        const pageIndex = changeJourneySteps.pages.findIndex(
          page => page.pageId === "makePayment"
        )
        changeJourneySteps.pages[pageIndex].sections = changeJourneySteps.pages[pageIndex].sections.filter(
          section => section.sectionId === "eNach-physicalMandate"
        )
      } else {
        // Remove SCR section for normal journey
        const pageIndex = changeJourneySteps.pages.findIndex(
          page => page.pageId === "uploadDocuments"
        )
        changeJourneySteps.pages[pageIndex].sections = changeJourneySteps.pages[pageIndex].sections.filter(
          section => section.sectionId !== "salesConfidentialReport"
        )
      }

      saveApplication(sendPayload).then(res => { 
        console.log(datatoPass, "data to pass") 
        sendSelectedOptions(datatoPass).then(res => {
          setJourneyState((prev) => {
            return ({
              ...prev,
              lastPage: props.currentPageIndex,
              lastSection: props.currentSectionIndex + 1,
              lastPageCode: props.pageId,
              lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
              journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId),
              journeySteps: changeJourneySteps
            })
          })
          props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
          console.log(res)
        })
      }).catch(err => {
        console.log(err, "err in saveApplication")
      })
    }
  }

  const sucRules = async () => {      
    //for la
    let laAge = getAge(apiResult?.lifeAssuredDetails?.dob)
    let weight = apiResult?.lifeAssuredDetails?.personalDetails?.weight
    let height = apiResult?.lifeAssuredDetails?.personalDetails?.cms
    let bmi = Number((weight / (height * height)) * 10000)

    //for spouse
    let spAge = getAge(apiResult?.spouseDetails?.dob)
    let spWeight = apiResult?.spouseDetails?.personalDetails?.weight
    let spHeight = apiResult?.spouseDetails?.personalDetails?.cms
    let spBmi = Number((spWeight / (spHeight * spHeight)) * 10000)
    let payload = {
      illustrationNumber: apiResult?.basicDetails?.illustrationNumber || "",
      source: apiResult?.basicDetails?.source,
      typeOfInsurance: apiResult?.basicDetails?.typeOfInsurance,
      referredByEmpNo: null,
      proposalType: apiResult?.basicDetails?.proposalType,
      applicationNumber: apiResult?.basicDetails?.applicationNumber,
      spAgentName: apiResult?.agentDetails?.spAgentName || "",
      channelType: "D",
      agentBankName: "Direct",
      spAgentCode: apiResult?.agentDetails?.spAgentCode,
      sellingBankBranch: "",
      clientRole: apiResult?.lifeAssuredDetails?.clientRole,
      dob: apiResult?.lifeAssuredDetails?.dob,
      ingeniumRefIds: [],
      unifiedRefId: apiResult?.basicDetails?.applicationNumber,
      ingeniumRefId: "",
      existingPolicyHolder: apiResult?.lifeAssuredDetails?.existingPolicyHolder,
      dedupeId: "",
      spouseSa: apiResult?.productDetails?.spouseLaDetails?.spouseSa,
      wishToSecure: apiResult?.productDetails?.spouseLaDetails?.wishToSecure,
      spouseStatus: apiResult?.productDetails?.spouseLaDetails?.spouseStatus,
      spouseCoverOption:
        apiResult?.productDetails?.spouseLaDetails?.spouseCoverOption,
      spousebenAmtRcvInd:
        apiResult?.productDetails?.spouseLaDetails?.spousebenAmtRcvInd,
      spouseBenefitPayoutOptionsInd:
        apiResult?.productDetails?.spouseLaDetails
          ?.spouseBenefitPayoutOptionsInd || "",
      spouseProportion:
        apiResult?.productDetails?.spouseLaDetails?.spouseProportion || "",
      riders: apiResult?.productDetails?.riders,
      bypSaPercent: apiResult?.productDetails?.riders?.rider?.[0]?.bypSaPercent,
      bypSpouseSaPercent:
        apiResult?.productDetails?.riders?.rider?.[0]?.bypSpouseSaPercent,
      bypInd: apiResult?.productDetails?.riders?.rider?.[0]?.bypInd,
      modeOfPayment: apiResult?.productDetails?.modeOfPayment,
      premiumFrequency: apiResult?.productDetails?.premiumFrequency,
      planName: apiResult?.productDetails?.planName,
      planOption: apiResult?.productDetails?.planOption,
      coverOption: apiResult?.productDetails?.coverOption,
      premiumPaymentTerm: apiResult?.productDetails?.premiumPaymentTerm,
      policyTerm: apiResult?.productDetails?.policyTerm,
      sumAssured: apiResult?.productDetails?.sumAssured,
      annulizedPremium: apiResult?.productDetails?.annulizedPremium,
      paymentKey: apiResult?.productDetails?.paymentKey || (apiResult?.productDetails?.installmentPremium),
      payorPPCOption: "Y",
      proposerDetails: {
        ingeniumRefIds: [],
        unifiedRefId: "",
        ingeniumRefId: "",
      },
      payorDetails: {
        unifiedRefId: "",
        ingeniumRefId: "",
        ingeniumRefIds: [],
      },
      eligibilityDataLa: {
        laAgeYears: laAge,
        laEducation:
          apiResult?.lifeAssuredDetails?.employmentDetails?.education,
        laOccupation:
          apiResult?.lifeAssuredDetails?.employmentDetails?.occupation,
        laAnnualIncome:
          apiResult?.lifeAssuredDetails?.employmentDetails?.annualIncome,
        laCountryNationality: apiResult?.lifeAssuredDetails?.countryOfResidence,
        laBmiMer: bmi,
        // financialSuc: sucRulesResult?.sucResponse?.[0]?.totalSUC?.totalSUC,
      },
      eligibilityDataSp: {
        spAgeYears: spAge,
        spEducation: apiResult?.spouseDetails?.employmentDetails?.education,
        spOccupation: apiResult?.spouseDetails?.employmentDetails?.occupation,
        spAnnualIncome:
          apiResult?.spouseDetails?.employmentDetails?.annualIncome,
        spCountryNationality: apiResult?.lifeAssuredDetails?.countryOfResidence,
        spBmiMer: spBmi,
        // financialSuc: sucRulesResult?.sucResponse?.[0]?.totalSUC?.totalSUC,
      },
    }
    console.log(payload)
    let temp = await fetchSucRules(payload)
    console.log(temp);
    return temp
}

  useEffect(() => {
    getAllJourneyData()
  }, [])

//Tele-Mer Page Check
  const teleMerPageCheck = (sucApiRes) => {
    console.log(sucApiRes?.dataLa?.response?.teleMerEligibility)
    console.log(sucApiRes?.dataSp?.response?.teleMerEligibility)

    let payload = {
      _id: apiResult?._id,
    }
    fetchApplicationDetails(payload).then(res => {
      console.log(res)
      console.log(sucApiRes?.dataLa?.response?.teleMerEligibility);
      console.log(sucApiRes?.dataSp?.response?.teleMerEligibility);
      let tempSectionToShow
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(
        element => element.pageId === "viewBenefitIllustrationPage"
      )
      if (
        sucApiRes?.dataLa?.response?.teleMerEligibility !== "Y" &&
        sucApiRes?.dataSp?.response?.teleMerEligibility !== "Y"
      ) {
        tempSectionToShow = temp.pages[tempPageIndexToChange].sections.filter(
          element => {
            return (
              element.sectionId !== "Tele-MER" &&
              element.sectionId !== "iselectTeleMedicalQuestionaire" &&
              element.sectionId !== "iselectTeleMedicalSpouseQuestionaire"
            )
          }
        )
      } else if (sucApiRes?.dataLa?.response?.teleMerEligibility !== "Y") {
        tempSectionToShow = temp.pages[tempPageIndexToChange].sections.filter(
          element => {
            return element.sectionId !== "iselectTeleMedicalQuestionaire"
          }
        )
      } else if (sucApiRes?.dataSp?.response?.teleMerEligibility !== "Y") {
        tempSectionToShow = temp.pages[tempPageIndexToChange].sections.filter(
          element => {
            return element.sectionId !== "iselectTeleMedicalSpouseQuestionaire"
          }
        )
      } else if (sucApiRes?.dataLa?.response?.teleMerEligibility === "Y" && 
                  sucApiRes?.dataSp?.response?.teleMerEligibility === "Y"){
        tempSectionToShow = temp.pages[tempPageIndexToChange].sections
      }
      console.log(tempPageIndexToChange, "adadadada")
      console.log(tempSectionToShow, "section to show")
      temp.pages[tempPageIndexToChange].sections = tempSectionToShow
      console.log(temp);

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
        }
      })
    })
  }

  const handleSubmit = async (ev)=>{
    let e ="proceed"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    try {
      const payload = {
        journeyId: journeyState?.journeyId, 
        buttonClicked: `provide-your-consent with ${checked} ` , 
      };

      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handleSubmit", error);
    }
    if(proceedOptionError){
      if(proceedOptionError === "This pincode is not serviceable"){
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : journeyState.journeyIdFromStrapi === "youngTermPlanJourney" ? "Young Term Plan" : ""}. Basis your input this Plan is not available.`)
        return 
      }else{
        errorToastr("BI could not be generated for the details selected. Please proceed by selecting any other option")
        return 
      }
    }
    let sucApiRes
    // let sucApiRes = await sucRules()
    console.log(sucApiRes);
    if(journeyState.journeyIdFromStrapi != "youngTermPlanJourney"){
      let teleMerApiRes = await teleMerPageCheck(sucApiRes)
    }

    console.log(journeyState);
    let sendPayload = {
      applicationData:  journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        premium: journeyState.premium,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        showLaTeleMer: sucApiRes?.dataLa?.response?.teleMerEligibility === "Y" ? true : false,
        showSpTeleMer: sucApiRes?.dataSp?.response?.teleMerEligibility === "Y" ? true : false
        // add keys here
      },
    }


    let temp = journeyState.journeySteps
    if (journeyState?.journeyType?.toLowerCase() === "canarapos" && apiResult.productDetails.premiumFrequency === "SG") {
      temp.pages = temp.pages.filter(
        page => page.pageId !== "makePayment"
      )
    }else if (journeyState?.journeyType?.toLowerCase() === "canarapos") {
      const pageIndex = temp.pages.findIndex(
        page => page.pageId === "makePayment"
      )
      temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
        section => section.sectionId === "eNach-physicalMandate"
      )
    } else {
      // Remove SCR section for normal journey
      const pageIndex = temp.pages.findIndex(
        page => page.pageId === "uploadDocuments"
      )
      temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
        section => section.sectionId !== "salesConfidentialReport"
      )
    }

    saveApplication(sendPayload).then(res => { 
      console.log(datatoPass, "data to pass") 
      sendSelectedOptions(datatoPass).then(res => {
        setJourneyState((prev) => {
          return ({
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex + 1,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex + 1].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex + 1].sectionId),
            // showLaTeleMer: sucApiRes?.dataLa?.response?.teleMerEligibility === "Y" ? true : false,
            // showSpTeleMer: sucApiRes?.dataSp?.response?.teleMerEligibility === "Y" ? true : false
            journeySteps: temp
          })
        })
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
        console.log(res)
      })
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const handleEnter =(event1,event2) =>{
    console.log({event2});
    if(event1.key == 'Enter'){
      handleSelection(event2)
    }
  }

  const handleSelection = ({target}) => {

    try {
      const payload = {
        journeyId: journeyState?.journeyId, 
        buttonClicked: `provide-your-consent with ${target.value} selection ` , 
      };

      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handleSelection", error);
    }

    if(target.value === "ekyc" || target.value === "ckyc"){
      let isPincodeOfSelectedOptionNegative
      if(target.value === "ekyc"){
        isPincodeOfSelectedOptionNegative = checkNegativePincode(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressPin)
      }else {
        isPincodeOfSelectedOptionNegative = checkNegativePincode(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddPin)
      }
      if(isPincodeOfSelectedOptionNegative){
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${journeyState.journeyIdFromStrapi === "iSelectJourney" ? "iSelect Star Plan" : journeyState.journeyIdFromStrapi === "ISelect360Journey" ? "iSelect Smart360 Term Plan" : journeyState.journeyIdFromStrapi === "youngTermPlanJourney" ? "Young Term Plan" : ""}. Basis your input this Plan is not available.`)
        setProceedOptionError("This pincode is not serviceable")
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
          selectedOption : target.value
        }
        checkBIExists(payload)
        .then(res => {
          console.log(res, "dsfdfdsfd")
          if(!res.data){
            errorToastr("BI could not be generated for the details selected. Please proceed by selecting any other option")
            setProceedOptionError("Cannot select this option")
            return 
          }else{
            setProceedOptionError("")
          }
        })
      }
    }else{
      setProceedOptionError("")
    }
    // console.log(target)
    switch (target.value) {
      case "ekyc":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "ekyc"
          })
        })
        setChecked("ekyc")
        break;
      case "ckyc":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "ckyc"
          })
        })
        setChecked("ckyc")
        break;
      case "dedupe":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "dedupe"
          })
        })
        setChecked("dedupe")
        break;
      case "manually":
        setDataToPass(prev => {
          return ({
            ...prev,
            "proceedOption": "manually"
          })
        })
        setChecked("manual")
        break;
      default:
        break;
    }
    // console.log(datatoPass)
  }

  const handleValueChange = ({ target }) => {
    // console.log(target.value)
    switch (target.value) {
      case "currentAddress":
        setDataToPass(prev => {
          return ({
            ...prev,
            "addressOption": "currentAddress"
          })
        })
        break;
      case "permanentAddress":
        setDataToPass(prev => {
          return ({
            ...prev,
            "addressOption": "permanentAddress"
          })
        })
        break;
      case "both":
        setDataToPass(prev => {
          return ({
            ...prev,
            "addressOption": "both"
          })
        })
        break;
    
      default:
        break;
    }
    // console.log(datatoPass)
  }

   // code of tab enter
   const handleEnterAddress = (event, event2) =>{
    if(event?.key == 'Enter'){
      handleValueChange(event2)
      // aadharOtp(event);
    }
  }

  return (
    <>
      {/* <Header /> */}
      <style>
        {`
            .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                margin-left:-2px;
            }
            ::-ms-clear {
                display: none;
            }
            @media (min-width: 768px) and (max-width: 991px) {
                .left-side-head {
                    width: 60%;
                }
            }
            .input-group.date .input-group-addon{
                background:none;
            }
        
            @media (max-width: 767px){
                .form-group {
                    margin-bottom: 34px;
                }    
            }    
            .d-none{
                display: none;
            }   
            .br-0{
                border-radius: 0px !important;
             }
             .abcd{
              display:flex;
              gap:2rem;
             }
        `}
      </style>

      {/* body Section */}
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head">
                    <h1 className="iselect-heading">
                      Provide your consent to proceed
                    </h1>
                  </div>
                  <div className="app-quatation q3-mt1 hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>
                {apiResult && 
                <div className="iselect-padding details-esign">
                  { apiResult.lifeAssuredDetails && 
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed to enter details manually{" "}
                          </span>
                          <input type="radio" name="spouse" value="manually" checked={checked === "manual" ? true : false} onChange={handleSelection} />
                      <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'manually'}})}  ></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                  </>
                  }
                  {(apiResult.lifeAssuredDetails.kycVerified) && 
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed with below details as per E-KYC Records{" "}

                          </span>
                          <input
                            type="radio"
                            name="spouse"
                            value="ekyc"
                            checked={checked === "ekyc" ? true : false}
                            onChange={handleSelection}
                          />
                          <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'ekyc'}})}></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                    <div class="row col-lg-12 col-md-12">
                    <div className="col-lg-6 col-md-12">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table"> Life Assured Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> First Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.kycFirstName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Middle Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.kycMiddleName)} </td>
                              </tr>
                              <tr>
                                <td className="clr-left"> Last Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.kycLastName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Gender </td>
                                <td align="right"> {lineCapital(getValueFromLookup("gender",apiResult?.lifeAssuredDetails?.kycDetails?.kycGender))} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Date of Birth </td>
                                <td align="right">{maskInFormat(apiResult?.lifeAssuredDetails?.kycDetails?.kycDateOfBirth * 1000) || "NA"} </td>
                              </tr>
                              <tr className="table-color hei-table">
                                <td></td>
                                <td align="right"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">
                          {" "}
                          Resident Address Details of Life Assured{" "}
                        </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> Address line 1 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine1 ? lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine1?.slice(0, 5) + "***********") : ""} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Address line 2 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine2 ? lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine2?.slice(0, 5) + "***********") : ""} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Address line 3 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine3 ? lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressLine3?.slice(0, 5) + "***********") : ""} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> State </td>
                                <td align="right"> {lineCapital(state[0][apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressState])} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">City </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressCity)}</td>
                              </tr>
                              <tr className="table-color ">
                                <td className="clr-left"> Pincode </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.kycDetails?.adharAddressPin)} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </>
                  }
                  {(apiResult.lifeAssuredDetails.ckycVerified) &&
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed with below details as per CKYC Records{" "}
                          </span>
                          <input type="radio" name="spouse" value="ckyc" checked={checked === "ckyc" ? true : false} onChange={handleSelection} />
                          <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'ckyc'}})}  ></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                    <div className="row col-lg-12 col-md-12">
                    <div className="col-lg-6 col-md-12">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table"> Life Assured Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> First Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCFirstName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Middle Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCMiddleName)} </td>
                              </tr>
                              <tr>
                                <td className="clr-left"> Last Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCLastName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Gender </td>
                                <td align="right">{lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCGender)}</td>
                              </tr>
                              <tr>
                                <td className="clr-left">Date of Birth </td>
                                <td align="right">{maskInFormat(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCDOB * 1000) || "NA"}</td>
                              </tr>
                              <tr className="table-color hei-table">
                                <td></td>
                                <td align="right"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">
                          {" "}
                          Resident Address Details of Life Assured{" "}
                        </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> Address line 1 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd1 ? lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd1?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Address line 2 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd2 ? lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd2?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Address line 3 </td>
                                <td align="right"> {apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd3 ? lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAdd3?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> State </td>
                                <td align="right"> {lineCapital(state[0][apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddState])} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">City </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddCity)} </td>
                              </tr>
                              <tr className="table-color ">
                                <td className="clr-left"> Pincode </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.ckycDetails?.CKYCCorAddPin)} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </>
                  }
                  {(apiResult?.lifeAssuredDetails?.matchTypeDedupe) && 
                  <>
                    <h2 className="headline-d">
                      <div className="radio-line radio-design">
                        <label className="customradio">
                          <span className="radiotextsty">
                            {" "}
                            Proceed with below details as per Canara HSBC Life
                            Insurance Records{" "}
                          </span>
                          <input type="radio" name="spouse" value="dedupe" checked={checked === "dedupe" ? true : false} onChange={handleSelection}  />
                          <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:'dedupe'}})}  ></span>{" "}
                        </label>
                      </div>
                    </h2>
                    <div className="clearfix"></div>
                    <div className="row col-lg-12 col-md-12">
                    <div className="col-lg-6 col-md-12">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table"> Life Assured Details </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> First Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.firstName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Middle Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.middleName)} </td>
                              </tr>
                              <tr>
                                <td className="clr-left"> Last Name </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.lastName)} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> Gender </td>
                                <td align="right"> 
                                {lineCapital(getValueFromLookup("gender",apiResult?.lifeAssuredDetails?.dedupeLa?.gender))}  </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Date of Birth </td>
                                <td align="right">  {maskInFormat(apiResult?.lifeAssuredDetails?.dedupeLa?.dob * 1000) || "NA"}   </td>
                              </tr>
                              <tr className="table-color hei-table">
                                <td></td>
                                <td align="right"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="table-responsive table-design">
                        <h2 className="headline-table">
                          {" "}
                          Resident Address Details of Life Assured{" "}
                        </h2>
                        <div className="table-bg">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="clr-left"> Address line 1 </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine1) ? lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine1?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left">Address line 2 </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine2) ? lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine2?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr>
                                <td className="clr-left">Address line 3 </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine3) ? lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTaddressLine3?.slice(0, 5) + "***********") : "NA"} </td>
                              </tr>
                              <tr className="table-color">
                                <td className="clr-left"> State </td>
                                <td align="right"> 
                                {lineCapital(state[0][apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTstate])}
                                {/* {apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTstate} */}
                                 </td>
                              </tr>
                              <tr>
                                <td className="clr-left">City </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTcity)} </td>
                              </tr>
                              <tr className="table-color ">
                                <td className="clr-left"> Pincode </td>
                                <td align="right"> {lineCapital(apiResult?.lifeAssuredDetails?.dedupeLa?.CURRENTpincode)} </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </>
                  }

                  <div className="iselect-mg-bottom">
                    <div className="col-md-12 col-xs-12 smace">
                      <div className="form-group">
                        <div className="radio-section-design">
                          <p>
                            Please confirm whether the selected address is your
                            current or permanent address?{" "}
                          </p>
                        </div>
                        <div className="radio-line radio-design sa11">
                          <label className="customradio">
                            <span className="radiotextsty">
                              Current Address
                            </span>
                            <input
                              type="radio"
                              name="spouse1"
                              value="currentAddress"
                              checked = {datatoPass.addressOption == 'currentAddress'?true:false}
                              onChange={handleValueChange}
                            />
                            <span className="provider checkmark" tabIndex="0" onKeyPress={ev=>handleEnterAddress(ev,{target:{value: "currentAddress"}})}></span>{" "}
                          </label>
                        </div>
                        <div className="radio-line radio-design">
                          <label className="customradio">
                            <span className="radiotextsty">
                              Permanent Address
                            </span>
                            <input
                              type="radio"
                              name="spouse1"
                              value="permanentAddress"
                              checked = {datatoPass.addressOption == 'permanentAddress'?true:false}
                              onChange={handleValueChange}
                            />
                            <span className="provider checkmark" tabIndex="0" onKeyPress={ev=>handleEnterAddress(ev,{target:{value:"permanentAddress"}})}></span>{" "}
                          </label>
                        </div>
                        <div className="radio-line radio-design">     
                          <label className="customradio">
                            <span className="radiotextsty">Both</span>
                            <input
                              type="radio"
                              name="spouse1"
                              value="both"
                              defaultChecked
                              checked = {datatoPass.addressOption == 'both'?true:false}
                              onChange={handleValueChange}
                            />
                            <span className="provider checkmark" tabIndex="0" onKeyPress={ev=>handleEnterAddress(ev,{target:{value:"both"}})}></span>{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-right">
                        <div
                          className="previous-btn cen"
                          style={{ display: "none" }}
                        >
                          {" "}
                          <a >Skip </a>{" "}
                        </div>
                        <a>
                          {" "}
                          <input
                            className="provider previous-btn cen"
                            tabIndex="0"
                            style={{
                              color: "white",
                              padding: "14px 40px",
                              border: "none",
                              backgroundColor: "#db0011 !important",
                            }}
                            type="submit"
                            value="Proceed"
                            onClick={handleSubmit}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div> 
            </div>
          </div>
        </div>
      </div>

      {/* body Section */}
      <div className="clearfix"></div>
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="previous-btn cen" style={{ display: "none" }}>
                {" "}
                <a>Skip </a>{" "}
              </div>
              <a>
                <input
                  className="previous-btn cen"
                  style={{
                    width: "auto",
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                    backgroundColor: "#db0011 !important",
                  }}
                  type="submit"
                  value="Proceed"
                  onClick={handleSubmit}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  )
}
